import * as React from 'react';
import { SVGProps } from 'react';

const IconVolumeDownSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m5.5 5 2.172-1.79C8.162 2.76 9 3.08 9 3.717v8.569c0 .636-.838.954-1.328.504L5.5 11H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.5ZM12.8 4.394a1 1 0 1 0-1.591 1.212C11.716 6.273 12 7.119 12 8c0 .881-.286 1.726-.795 2.393a1 1 0 0 0 1.59 1.214A5.955 5.955 0 0 0 14 8.002c0-1.307-.419-2.581-1.2-3.608Z" />
  </svg>
);
export default IconVolumeDownSizeS;
